import React, { useEffect, useState } from "react";
import "./ProductDetails.css";
import { Container, Row, Col } from "react-bootstrap";
import {
  Header,
  Details,
  ProductPecification,
} from "../../Features/ProductDetails/index";

import { Devices } from "../../Features/Home";
import axios from "axios";
import { useLocation } from "react-router-dom";

const ProudctDetails = ({ url }) => {
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const itemName = searchParams.get("item_name");

  useEffect(() => {
    if (productData) {
      setLoading(false);
    }
  }, [productData]);



  useEffect(() => {
    if (itemName) {
      fetchProductDetailsData(itemName);
    }
  }, [itemName]);

  const [hashmapSpecifications, setHashmapSpecifications] = useState({});

  function extractSpecifications(data, result = {}) {
    for (const [key, value] of Object.entries(data)) {
        if (typeof value === 'object' && value !== null) {
            if (value.is_group === 0) {
                result[key] = value;
            } else {
                extractSpecifications(value, result);
            }
        }
    }
    return result;
}

  const fetchProductDetailsData = async (itemName) => {
    var headers = { "Content-Type": "application/json" };
    try {
      const response = await axios.get(
        `${url}/api/method/webshop.webshop.doctype.website_item.website_item.items?name=${itemName}&with_specification_tree=1`,
        { headers: headers }
      );

      let _temp = extractSpecifications(response?.data?.result?.tree?.specifications);
      let updatedTemp = { ..._temp, ...extractSpecifications(response?.data?.result?.tree?.features) };

      setHashmapSpecifications(updatedTemp);
      
      setProductData(response?.data?.result || []);

      
      // console.log("hashmapSpecifications")
      // console.log(hashmapSpecifications)

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   console.log("hashmapSpecifications", hashmapSpecifications);
  // }, [hashmapSpecifications]);


  

  return (
    <div className="product-details-container">
      <div className="product-details-container">
        <Container>
          <Header productData={productData} url={url} />
        </Container>
      </div>
      <Container>
        <Details productData={productData} url={url} />
        <ProductPecification productData={productData} url={url} hashmapSpecifications={hashmapSpecifications} />
      </Container>
      <Devices url={url} homeLoading={loading} fromDetails={true} />
    </div>
  );
};

export default ProudctDetails;
